module.exports = __webpack_public_path__ + "img/banner-right.ef5cc412.png";